import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import FormsModal from "../../components/userForms/FormsModal";
import sky from './sky.png'
import './responsive.css'

export default function Header() {
  const [accountLink, setAccountLink] = useState("/");
  let token = localStorage?.getItem("skiUserToken");
  useEffect(() => {
    if (token) {
      const decodedToken = jwt_decode(token);
      const { AccountType } = decodedToken;
      AccountType === "admin"
        ? setAccountLink(AccountType + "-dashboard")
        : setAccountLink(AccountType + "-home");
    }
  }, [token]);
  return (
    <>
      <div className="Header">
        <div>
          <Link to="/">
            <img src={sky} alt="Ski sign" className="img" />
          </Link>
        </div>
        <div>
        </div>
        <div>
          {!localStorage?.getItem("skiUserToken") ? (
            <Link
              to="/"
              type="button"
              className="shadow-none btn btn-primary"
              data-toggle="modal"
              data-target="#exampleModalCenter"
              style={{ border: "none" }}
            >
              Get started
            </Link>
          ) : (
            <Link to={accountLink}>Go to your account</Link>
          )}
        </div>
      </div>
      <FormsModal />
    </>
  );
}
